import * as Headless from "@headlessui/react";
import { PropsWithChildren, ReactElement } from "react";

import { CloseMenuIcon } from "./CloseMenuIcon.tsx";
import { NavbarItem } from "./NavbarItem.tsx";

export const MobileSidebar = ({
  children,
  close,
  open,
}: PropsWithChildren<{
  close: () => void;
  open: boolean;
}>): ReactElement => (
  <Headless.Dialog className="lg:hidden" onClose={close} open={open}>
    <Headless.DialogBackdrop
      className="fixed inset-0 bg-black/30 transition data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      transition
    />
    <Headless.DialogPanel
      className="fixed inset-y-0 w-full max-w-80 p-2 transition duration-300 ease-in-out data-[closed]:-translate-x-full"
      transition
    >
      <div className="flex h-full flex-col rounded-lg bg-white shadow-sm ring-1 ring-zinc-950/5 dark:bg-zinc-900 dark:ring-white/10">
        <div className="-mb-3 px-4 pt-3">
          <Headless.CloseButton aria-label="Close navigation" as={NavbarItem}>
            <CloseMenuIcon />
          </Headless.CloseButton>
        </div>
        {children}
      </div>
    </Headless.DialogPanel>
  </Headless.Dialog>
);
